class ResourceConfig {
  
    static initRoute ($stateProvider, $urlRouterProvider) {
      'ngInject';
      $stateProvider.state('protected.users.resource', {
        url: "/resource",
        abstract: true,
        template: require("./resource.html"),
        controller: "ResourceUsersController as resource",
        resolve: {
          currentResourceWebsocket: ($q, $rootScope, $localStorage, ResourceService) => {
            var deferred = $q.defer();
    
            if(!$localStorage.loggedUser || !$localStorage.loggedUser.currentResourceCredentails){
              deferred.reject('AUTH_REQUIRED')
              return deferred.promise;
            }

            if(!ResourceService.getCurrentResourceWebsocket()) {
              $rootScope.mainProgressVisible = true;
              var loginResPromise = ResourceService.login($localStorage.loggedUser.currentResourceCredentails.userLogin, $localStorage.loggedUser.currentResourceCredentails.resource);
              loginResPromise.then(function(){
                if(!ResourceService.getCurrentUserResources()){
                  ResourceService.setCurrentUserResources($localStorage.loggedUser.resources);
                }

                $rootScope.mainProgressVisible = false;
                deferred.resolve(); 
              }, function(error){
                console.error('resource state resolve - login to resource error', error);
                deferred.reject('AUTH_REQUIRED')
              })
            } else {
              deferred.resolve(); 
            }
            
            return deferred.promise;
          }
        }
      }).state('protected.users.resource.fhome_radio', {
        url: "/fhomeradio",
        template: require("./fhomeradio.html"),
        controller: "FhomeRadioResourceUsersController as fhomeradioresource"
      }).state('protected.users.resource.notFound', {
        url: "/notFound",
        template: require("./notFound.html"),
        controller: "ResourceNotFoundUsersController as resourcenotfound"
      });
    }
  }
  
  export default ResourceConfig.initRoute;
  


// WEBPACK FOOTER //
// ./src/users/resource/resource.config.js